<div class="empower-line flex gap-20px">
    <img [src]="iconSrc" height="50" alt="">
    <div class="flex flex-column gap-5px">
        <h3>{{title}}</h3>
        <span>{{description}}</span>
        <ng-content></ng-content>
    </div>
</div>
